module.exports = __webpack_public_path__ + "static/media/AlternateSuggestions.125f074b.svg";